<template>
    <div>
        <span class="text-gray-500 mr-1">{{ $t('CUSTOM_PAINTFILL') }}</span>
        <span class="text-gray-500 mr-1">|</span>
        <span class="text-gray-500 mr-1">{{ $t('YES') }}</span>
        <a href="#" @click.prevent.stop="navigateToPaintfill"
            class="underline font-oceanside"
        >
            {{ $t('VIEW_DETAILS') }}
        </a>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        methods: {
            navigateToPaintfill() {
                this.customizerStore.openAllColorLocationsPanel({
                    source: 'CurrentSelection',
                });
            },
        },
    };
</script>